/**
 * Facebook login Component
 */
/* jshint ignore:start */
(function (itxApp) {

    'use strict';

    /**
     * Facebook login Component
     * @name facebookLoginCtrl
     * @type ItxFacebookLoginCmpCtrl
     */
    var ItxFacebookLoginCmp = {
        bindings: {
            onLogin: '&',
            btnClass: '@'
        },
        require: {
            'userAccessCtrl': '?^itxUserAccess'
        },
        controller: ItxFacebookLoginCmpCtrl,
        controllerAs: 'facebookLoginCtrl',
        templateUrl: ['$element', '$attrs', function ($element, $attrs) {
            return $attrs.template || 'facebook-login.tpl';
        }]
    };

    ItxFacebookLoginCmpCtrl.$inject = [
        '$scope',
        'ItxLoaderFct',
        'ItxErrorMessagesFct',
        'ngDialog',
        'ItxLoginSvc',
        '$timeout'
    ];

    function ItxFacebookLoginCmpCtrl(
        $scope,
        ItxLoaderFct,
        ItxErrorMessagesFct,
        ngDialog,
        ItxLoginSvc,
        $timeout
    ) {
        var _this = this;
        _this.$scope = $scope;
        _this.user = {};

        _this.$onInit = function () {
            _this.fbReady = false;
            _this.access_token = null;
            _this.showFbLogin = false;

            var facebookLoginEnabled;
            
            inditex.onReady(function () {
                
                if (inditex.iStoreJSON.configurations) {
                    facebookLoginEnabled = inditex.iStoreJSON.configurations.find(function (config) {
                        return config.parametro === 'FACEBOOK_LOGIN_ENABLED'
                    });
                }

                if (facebookLoginEnabled && facebookLoginEnabled.valor === '1' && !window.fbAppId) {
                    window.fbAppId = true;
                    window.showFbLogin = true;
                    inditex.getXConfigParameter('FACEBOOK_APP_ID', function (value) {
                        if (value) {
                            inditex.fbAppId = value.value;
                            _this.init(value.value);
                        }
                    });
                }

            });
           

        };

        $scope.$watch(
            function () {
                return window.showFbLogin;
            },
            function (newVal) {
                _this.showFbLogin = newVal;
            });

        _this.init = function (fbAppId) {

            (function (d) {
                // load the Facebook javascript SDK
                var js,
                    id = 'facebook-jssdk',
                    ref = d.getElementsByTagName('script')[0];

                if (d.getElementById(id)) {
                    _this.fbReady = true;
                    return;
                }

                js = d.createElement('script');
                js.id = id;
                js.async = true;
                js.src = "//connect.facebook.net/" + getFbLang(inditex.iLocale) + "/sdk.js";

                ref.parentNode.insertBefore(js, ref);

            }(document));

            window.fbAsyncInit = function () {
                FB.init({
                    appId: fbAppId, // the app id of the web app
                    status: true, // check the authentication status at the start up of the app
                    cookie: true, // enable cookies to allow the server to access the session
                    xfbml: true, // parse xfbml
                    version: 'v2.8' // graph api version
                });

                _this.fbReady = true;
                $timeout();
            };

        }

        // Login in FB to get the access token
        _this.login = function () {
            var _this = this,
                authFB = FB.getAuthResponse();

            if (authFB) {
                _this.access_token = authFB['accessToken'];
            }

            FB.getLoginStatus(function (loginStatus) {
                if (_this.access_token && _this.access_token != '' && loginStatus.status == 'connected') {
                    setUserDataAndLogin();
                } else {
                    FB.login(function (response) {
                        if (response.authResponse) {
                            _this.access_token = FB.getAuthResponse()['accessToken'];
                            setUserDataAndLogin();
                        }
                    }, {
                            'scope': 'email, public_profile',
                            'return_scopes': true
                        });
                }
            });
        }

        // REST social login
        _this.socialLogin = function (user, closeDialog) {
            if (user.socialId && user.socialId != '' && user.socialToken && user.socialToken != '') {
                ItxLoaderFct.show();

                ItxLoginSvc.socialLogin(user)
                .then(function (userJSON) {
                        // FBTODO: social login successful
                        inditex.iUserJSON = userJSON;
                        sessionStorage.setItem("cache-current-user", JSON.stringify(inditex.iUserJSON));

                        if(closeDialog) ngDialog.close();
                        if (_this.userAccessCtrl)  _this.userAccessCtrl.closeDialog();
                        if (_this.onLogin) _this.onLogin();

                        $timeout();
                })
                .catch(function (error) {
                    // Social login failed
                    switch (error.errorKey) {
                        case 'INVALID_SOCIAL_USER_NEED_EMAIL':
                            OpenRegisterAccountDialog();
                            break;
                        case '_APP_PERSON_REGISTER':
                            OpenRegisterAccountDialog();
                            break;
                        case 'INVALID_SOCIAL_USER_NEED_PASSWORD':
                            OpenLinkAccountDialog();
                            break;
                        default:
                            // Generic error
                            ItxErrorMessagesFct.dialog(error.errorMessage);
                            break;
                    }
                })
                .finally(function () {
                    ItxLoaderFct.hide();
                    $timeout()
                });
            }
        }

        function setUserDataAndLogin() {
            FB.api('/me', {
                fields: 'id, name, last_name, email, picture'
            }, function (response) {
                _this.user = {
                    socialId: response.id,
                    socialToken: _this.access_token,
                    name: response.name,
                    email: response.email,
                    image: response.picture.data.url
                }
                var userData = {
                    socialId: response.id,
                    socialToken: _this.access_token
                }
                _this.socialLogin(userData);
            });
        }

        function getFbLang(locale) {
            var languageMap = {
                "de_AT": "de_DE",
                "fr_BE": "fr_FR",
                "es_IC": "es_ES",
                "fr_LU": "fr_FR",
                "de_LU": "de_DE",
                "de_CH": "de_DE",
                "it_CH": "it_IT",
                "fr_CH": "fr_FR"
            }

            if (languageMap[locale] != undefined) {
                return languageMap[locale];
            }
            return locale;
        }

        function OpenLinkAccountDialog(emailReadonly) {
            ngDialog.open({
                template: '<itx-social-login-link-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-link-account-dialog>',
                plain: true,
                className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
                showClose: true,
                data: {
                    user: _this.user,
                    onContinue: _this.socialLogin
                }
            });
        }

        function OpenRegisterAccountDialog(emailReadonly) {
            ngDialog.open({
                template: '<itx-social-login-register-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-register-account-dialog>',
                plain: true,
                className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
                showClose: true,
                data: {
                    user: _this.user,
                    onContinue: _this.socialLogin
                }
            });
        }

    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxFacebookLogin', ItxFacebookLoginCmp);

    itxApp.common.ItxFacebookLoginCmp = ItxFacebookLoginCmp;
    itxApp.common.ItxFacebookLoginCmpCtrl = ItxFacebookLoginCmpCtrl;

})(window.itxApp);
/* jshint ignore:end */